import { useEffect, useState } from 'react';

/**
 * Sleduje GPS pozici telefonu přes `navigator.geolocation.watchPosition`.
 * Pozice se NEUKLÁDÁ serverově — jen pro vykreslení v cockpitu. Server-side
 * tracking řeší Traccar / vozidlo.
 *
 * Vrátí `null` pokud:
 *   - prohlížeč nepodporuje geolokaci
 *   - uživatel nepovolil přístup
 *   - pozice se nepodařila získat
 */
export default function useGpsPoloha({ enabled = true } = {}) {
    const [poloha, setPoloha] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!enabled || !navigator.geolocation) return;

        const id = navigator.geolocation.watchPosition(
            (pos) => {
                setPoloha({
                    lat: pos.coords.latitude,
                    lng: pos.coords.longitude,
                    accuracy: pos.coords.accuracy,
                    heading: pos.coords.heading,
                    speed: pos.coords.speed,      // m/s, null když ho telefon nedá
                });
                setError(null);
            },
            (err) => setError(err.message),
            // maximumAge krátký — starý bod z cache se po čerstvém vrátí a šipka cukne zpátky
            { enableHighAccuracy: true, maximumAge: 1000, timeout: 15000 }
        );

        return () => navigator.geolocation.clearWatch(id);
    }, [enabled]);

    return { poloha, error };
}
